import { render, staticRenderFns } from "./CtrlTratativasPage.vue?vue&type=template&id=423655ac"
import script from "./CtrlTratativasPage.vue?vue&type=script&lang=js"
export * from "./CtrlTratativasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports